const countryToRegionMapping = {
  GB: 'Europe',
  FR: 'Europe',
  DE: 'Europe',
  IT: 'Europe',
  NL: 'Europe',
  BR: 'LATAM',
  JP: 'APAC 2',
  PL: 'Europe',
  CL: 'LATAM',
  BE: 'Europe',
  TR: 'Middle East',
  CH: 'Europe',
  IN: 'APAC 1',
  AT: 'Europe',
  PT: 'Europe',
  GR: 'Europe',
};

const getRetailerRegionByCountryCode = (countryCode: string): string | undefined => countryToRegionMapping[countryCode];

export default getRetailerRegionByCountryCode;
